<template>
    <div class="Gallery">

    </div>
</template>

<script>
    export default {
        name:'gallery',
        props: {
            content: Object
        },
        created() {
        }
    }
</script>

<style lang="scss">

</style>



